import { QueryResult } from '@apollo/client'
import { GetOrganizationsQuery, useGetOrganizationsQuery } from 'schema'
import { createStrictContext } from 'utils/createContext'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { useProjectContext } from 'context/ProjectContext'

type GetOrganizationsQueryResult = QueryResult<GetOrganizationsQuery>
export type Organization =
  GetOrganizationsQuery['dsOrganizations']['records'][0]

const { Provider, useContextFn } = createStrictContext<{
  records: Organization[]
  refetch: GetOrganizationsQueryResult['refetch']
  fetching: GetOrganizationsQueryResult['loading']
}>('OrganizationsTableContext')

export const useOrganizationsTableContext = useContextFn

export const OrganizationsTableProvider: React.FC = ({ children }) => {
  const { projectId } = useProjectContext()
  const {
    data,
    refetch,
    loading: fetching,
  } = useGetOrganizationsQuery({
    ...DefaultQueryHookOptions,
    variables: {
      dsOrganizationListInput: {
        projectId: { equals: projectId },
      },
    },
  })
  return (
    <Provider
      value={{
        records: data?.dsOrganizations?.records ?? [],
        refetch,
        fetching,
      }}
    >
      {children}
    </Provider>
  )
}
